<template>
   <section>
    <header class="header pt-2 pb-2">
        <label class="" for="mobile-menu-checkbox" id="mobile-menu-btn">
            <span class="menu-link" @click="back"><i class="fas fa-arrow-left"></i></span>            
        </label>
        <span class="screen_title lead capitalize ">{{appbarTitle}}</span>
    </header>

</section>
</template>

<style scoped>
 :root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }
    * {
        outline: none;
    }
 
    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    /*Scroll - END*/
 
 
        #mobile-menu-checkbox {
            display: none;
            margin: 0px 0px 0px !important;
        }

        #mobile-menu-checkbox:checked ~ #mobile-menu-overlay {
            display: block;
            margin: 0px 0px 0px !important;
        }

        #mobile-menu-checkbox:checked ~ .mobile-menu {
            visibility: visible;
            margin: 0px 0px 0px !important;
            transform: translate3d(0, 0, 0);
        }

        #mobile-menu-overlay {
            background-color: rgba(0, 0, 0, 0.6);
            display: none;
            height: 100%;
            left: 0;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 100;
        }

        .mobile-menu {
            position: fixed;
            left: 0;
            z-index: 101;
            top: 0;
            visibility: hidden;
            width: 300px;
            height: 100%;
            background: #ffffff;
            color: white;
            transition: all 0.2s;
            transform: translate3d(-100%, 0, 0);
            padding: 10px;
        }

        .mobile-menu h1 {
            color: black;
        }

        #mobile-menu-btn {
            background-color: transparent;
            border: none;
            color: #222;
            font-size: 20px;
            font-weight: 300;
            left: 0;
            line-height: 1.6em;
            position: relative;
            padding: 0;
            margin: 0px 0px 0px !important;
            cursor: pointer;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        header {
            background-color: #ffffff;
            padding: 0.2em;
            position: fixed;
            z-index: 100;
            width: 100%;
            top: 0;
        }

        header .menu-link {
            color: #333;
            text-transform: uppercase;
            padding-left: 10px;
            margin-top: auto;
        }

        #items {
            line-height: 1.75;
        }

        .img-profile-parent {
            background-color: #49265C !important;
            border-radius: 10px !important;
            padding-left: 10px !important;
            padding-top: 10px !important;
            padding-bottom: 10px !important;
            margin: 10px !important;
        }

        .ic_back {
            color: #333;
            font-weight: bold;
            font-size: 20px;
        }

        ul {
            padding: 0px 0px 0px 0px;
        }

        .main-menu-link {
            color: #49265C !important;
            font-weight: bold !important;
            line-height: 40px !important;
            padding-left: 10px !important;
            padding-top: 2px !important;
            padding-bottom: 2px !important;
            display:block;
        }

        a:focus {
            text-decoration: none;
        }

        a:active {
            text-decoration: none;
        }

 /*This will center the title START*/
        .screen_title {
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-right: -50%;
            transform: translate(-50%, -50%)
        }

        /*This will center the title END*/


</style>

<script>    
    export default {
       props: {
            title: String,
            moduleRoute: String,
            appbarTitle: String,
        },
        
         data() {
        return {
              canRegister:true,
            ///url: '/', 
        }
    },
    methods: {
        showBackButton(){
           // console.log("Back Button Visible");
        },
        logout() {
            this.$inertia.post(route("logout"));
        }
        ,onBackPressed(){
            app.onBackPressed();
        },
          back() {
            window.history.back();

            // this.$inertia.get('/'+this.moduleRoute);
    },
  },
  mounted() {
    
  },
}
</script>

